import * as React from "react";
import { Navigate } from "react-router-dom";
import AuthService from "@/services/AuthService";

/**
 * SupportAdminRoute — gates a route to explicitly authorized support identities.
 *
 * Passes for:
 *   1. Users with IsVelaroAdmin = true (explicitly granted — full access)
 *   2. Users with IsVelaroSupport = true (explicitly granted — view-only access)
 *
 * Site-ID allowlist (100050/100060) and email-domain (@velaro.com) checks were intentionally
 * removed. Being on site 1032 does NOT grant access — the flag must be explicitly granted
 * per-person. Only existing VelaroAdmins can grant IsVelaroAdmin; any VelaroAdmin can grant
 * IsVelaroSupport.
 *
 * To grant access: Support Tools → find user → toggle role.
 */
export function SupportAdminRoute({ children }: { children: React.ReactNode }) {
  const profile = AuthService.profile;
  const isVelaroAdmin = profile?.isVelaroAdmin === true;
  const isVelaroSupport = profile?.isVelaroSupport === true;

  if (!isVelaroAdmin && !isVelaroSupport) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}

export default SupportAdminRoute;
